import React, { useEffect, useRef, useState } from "react";
import "../NavbarLinksCSS/Contact.css";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";

import { Message } from "primereact/message";
import { InputTextarea } from "primereact/inputtextarea";
import ContactUsimg from "../../Images/Contact_usformN.png";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { FiRefreshCw } from "react-icons/fi";
import { IoCallOutline } from "react-icons/io5";
import { TbWorldWww } from "react-icons/tb";
import { TfiEmail } from "react-icons/tfi";
import { useNavigate } from "react-router-dom";
import ContactUsBanner from "../../AVHRBanner/ContactUsBanner.png";
import {
  FaUserTie, FaClipboardList, FaMoneyCheckAlt, FaUsers, FaChartLine,
  FaHeartbeat, FaBalanceScale, FaChalkboardTeacher, FaUserGraduate,
  FaPeopleCarry, FaBrain, FaUserFriends, FaTools, FaPiggyBank,
  FaGlobeAmericas, FaBookOpen
} from "react-icons/fa";


function ContactUsPage() {
  const [invalid, setInvalid] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [answer, setAnswer] = useState("");
  const [captchaText, setCaptchaText] = useState("");
  const [text, setText] = useState("");
  const [fullName, setFullName] = useState("");
  const [emailID, setEmailID] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [subject, setSubject] = useState("");
  const [contactReason, setContactReason] = useState("");
  const [mobilePrefix, setMobilePrefix] = useState(91);
  const toast = useRef(null);


  const generateCaptcha = () => {
    const number1 = Math.floor(Math.random() * 10) + 1;
    const number2 = Math.floor(Math.random() * 10) + 1;
    const operation = Math.random() < 0.5 ? "+" : "-";
    const result = operation === "+" ? number1 + number2 : number1 - number2;

    setCaptchaText(`${number1} ${operation} ${number2} = `);
    setAnswer(result.toString());
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const response = await fetch("/api/send-email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fullName: fullName,
        email: emailID,
        subject: subject,
		mobileNumber:mobileNumber,
        contactReason: contactReason,
      }),
    });

    if (response.ok) {
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Form submitted successfully.",
        life: 3000,
      });
      setLoading(false);
      // setFullName("");
      // setEmail("");
      // setMessage("");
      // setSubject("");
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error submitting form.",
        life: 3000,
      });
    }
    setLoading(false);
  };

  const handleSaveContactUsEnquiry = async (event) => {
    event.preventDefault();

    if (answer !== text) {
      toast.current.show({
        severity: "error",
        summary: "Invalid Captcha",
        detail: "Please enter a valid Captcha",
        life: 2000,
      });
      setInvalid(true);
      generateCaptcha();
      return;
    }

    setInvalid(false);

    if (!fullName || fullName.length < 3 || fullName.length > 50) {
      toast.current.show({
        severity: "error",
        summary: "Invalid Name",
        detail: "Please enter a valid full name (3–50 characters).",
        life: 2000,
      });
      return;
    }

    if (!emailID || !/\S+@\S+\.\S+/.test(emailID)) {
      toast.current.show({
        severity: "error",
        summary: "Invalid Email",
        detail: "Please enter a valid email address.",
        life: 2000,
      });
      return;
    }

    if (!mobileNumber || mobileNumber.length !== 10 || isNaN(mobileNumber)) {
      toast.current.show({
        severity: "error",
        summary: "Invalid Number",
        detail: "Please enter a valid 10-digit mobile number.",
        life: 2000,
      });
      return;
    }

    if (!subject || subject.length < 3 || subject.length > 200) {
      toast.current.show({
        severity: "error",
        summary: "Invalid Subject",
        detail: "Subject must be between 3 and 120 characters.",
        life: 2000,
      });
      return;
    }

    if (
      !contactReason ||
      contactReason.length < 3 ||
      contactReason.length > 1000
    ) {
      toast.current.show({
        severity: "error",
        summary: "Invalid Reason",
        detail: "Reason must be between 3 and 250 characters.",
        life: 2000,
      });
      return;
    }

    try {
      const response = await fetch("/saveContactUsEnquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          fullName,
          emailID,
          mobileNumber: parseInt(mobilePrefix + "" + mobileNumber),
          subject,
          contactReason,
        }),
      });

      if (response.ok) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Contact form data saved successfully.",
          life: 2000,
        });

        // Reset form
        setFullName("");
        setEmailID("");
        setMobilePrefix(91);
        setMobileNumber("");
        setSubject("");
        setContactReason("");
        setText("");
        generateCaptcha();
      } else {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "Failed to save contact form data. Try again later.",
          life: 2000,
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "An error occurred while submitting the form.",
        life: 2000,
      });
    }
  };

  const handleMailClick = () => {
    window.location.href = 'mailto:team@av-cs.in';
  };

  const handlePhoneClick = () => {
    window.open(`tel:+91 9100-030-567`, "_blank");
  };

  const handleWebsiteClick = () => {
    window.open(`https://av-cs.in/`, "_blank");
  };

  console.log(subject) 
  
  const enquiryGroups = [
    {
      label: 'HR Services',
      items: [
        { label: 'Executive Hiring', value: 'Executive Hiring', icon: <FaUserTie /> },
        { label: 'Pre & Post Onboarding', value: 'Pre & Post Onboarding', icon: <FaClipboardList /> },
        { label: 'Payroll Management', value: 'Payroll Management', icon: <FaMoneyCheckAlt /> },
        { label: 'Employee Engagement', value: 'Employee Engagement', icon: <FaUsers /> },
        { label: 'Performance Management', value: 'Performance Management', icon: <FaChartLine /> },
        { label: 'Employee Benefits & Wellness', value: 'Employee Benefits & Wellness', icon: <FaHeartbeat /> },
        { label: 'Statutory & Compliance', value: 'Statutory & Compliance', icon: <FaBalanceScale /> },
      ]
    },
    {
      label: 'Coaching & Facilitation',
      items: [
        { label: 'Executive Coaching', value: 'Executive Coaching', icon: <FaChalkboardTeacher /> },
        { label: 'Career Transition', value: 'Career Transition', icon: <FaUserGraduate /> },
        { label: 'Team Building', value: 'Team Building', icon: <FaPeopleCarry /> },
      ]
    },
    {
      label: 'Edu Support',
      items: [
        { label: 'AI Powered Psychometric Tests', value: 'AI Powered Psychometric Tests', icon: <FaBrain /> },
        { label: 'Personal Counselling', value: 'Personal Counselling', icon: <FaUserFriends /> },
        { label: 'Skill Building', value: 'Skill Building', icon: <FaTools /> },
        { label: 'Financial Planning', value: 'Financial Planning', icon: <FaPiggyBank /> },
        { label: 'Study Abroad', value: 'Study Abroad', icon: <FaGlobeAmericas /> },
        { label: 'Career Library', value: 'Career Library', icon: <FaBookOpen /> },
      ]
    }
  ];

  const itemTemplate = (option) => (
    <div className="flex align-items-center">
      <span className="mr-2">{option.icon}</span>
      <span>{option.label}</span>
    </div>
  );

  const valueTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <span className="mr-2">{option.icon}</span>
          <span>{option.label}</span>
        </div>
      );
    }
    return <span className="">{props.placeholder}</span>;
  };

  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={ContactUsBanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour">
              <p className="edu-support-text uppercase">Get in touch</p>

              <h1 className="career-library-heading">Contact Us</h1>
            </div>
          </div>
        </div>

        <div className="ContactSection">
          <Toast ref={toast} />

          <div className="contact-subsection-left">
            <div className="innersection-left">
              <img src={ContactUsimg} alt="contactimage" />
              <p>Feel Free to reach out to us!</p>
              <div className="contacts-sources">
                <Message
                  className="contcatDblock  avhrProject-h3"
                  severity="info"
                  text="+91 9100-030-567"
                  onClick={handlePhoneClick}
                  icon={<IoCallOutline className="contact-icon" />}
                />
                <Message
                  className="contcatDblock avhrProject-h3"
                  severity="info"
                  text="team@av-cs.in"
                  onClick={handleMailClick}
                  icon={<TfiEmail className="contact-icon" />}
                />
                <Message
                  className="contcatDblock avhrProject-h3"
                  severity="info"
                  style={{ marginBottom: "30px" }}
                  onClick={handleWebsiteClick}
                  text="https://av-cs.in/"
                  icon={<TbWorldWww className="contact-icon" />}
                />
              </div>
            </div>
          </div>

          <div className=" contact-subsection-right">
            <h2 className="Contact-heading avhrProject-h2">Enquiry Now</h2>
            <Card style={{ boxShadow: "none" }} className="contact-form">
              <form onSubmit={handleSaveContactUsEnquiry} method="post">
                {/* handleSubmit */}
                <table className="contact-form-table" cellPadding={"8px"}>
                  <tbody>
                    <tr>
                      <td colSpan={2} className="floating-label-container">
                        <InputText
                          keyfilter={/^[a-zA-Z ]*$/}
                          value={fullName}
                          onChange={(e) => setFullName(e.target.value)}
                          pattern=".{3,50}"
                          placeholder=" "
                        />
                        <div className="label-line">Enter Your Name</div>
                      </td>
                    </tr>

                    <tr>
                      <td
                        colSpan={2}
                        className="floating-label-container mobile-label"
                      >
                        <Dropdown
                          options={[{ name: "+91", value: 91 }]}
                          value={mobilePrefix}
                          onChange={(e) => setMobilePrefix(e.value)}
                          optionLabel="name"
                          placeholder="+91"
                          className="drop-down-contact"
                          style={{ zIndex: "2" }}
                        />
                        <InputText
                          className="contact-number"
                          keyfilter="pint"
                          placeholder=" "
                          pattern=".{10}"
                          value={mobileNumber}
                          onChange={(e) => setMobileNumber(e.target.value)}
                        />

                        <div className="label-line">Contact Number</div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={2} className="floating-label-container">
                        <InputText
                          type="email"
                          placeholder=" "
                          keyfilter={"email"}
                          value={emailID}
                          onChange={(e) => setEmailID(e.target.value)}
                        />
                        <div className="label-line">Enter Your Email</div>
                      </td>
                    </tr>

                    {/* <tr>
                      <td colSpan={2} className="floating-label-container">
                        <Dropdown
                          value={subject}
                          options={enquiryGroups}
                          onChange={(e) => setSubject(e.value)}
                          optionGroupLabel="label"
                          optionGroupChildren="items"
                          placeholder="Select Enquiry"
                          className="w-full"
                        />
						keyfilter={/^[a-zA-Z0-9 ]*$/}
                        <div className="label-line">Enquiry About</div>
                      </td>
                    </tr> */}


                    <tr>
                      <td colSpan={2} className="floating-label-container">
                        <Dropdown
                          value={subject}
                          options={enquiryGroups}
                          onChange={(e) => setSubject(e.value)}
                          optionGroupLabel="label"
                          optionGroupChildren="items"
                          placeholder="Enquiry About"
                          className="w-full"
                          filter
                          itemTemplate={itemTemplate}
                          valueTemplate={valueTemplate}
                        />
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={2} className="floating-label-container">
                        <InputTextarea
                          style={{ width: "100%" }}
                          rows={5}
                          value={contactReason}
                          placeholder=" "
                          onChange={(e) => setContactReason(e.target.value)}
                          cols={30}
                        />
                        <div className="label-line">Let us know more details...</div>
                      </td>
                    </tr>

                    <tr>
                      <td style={{ padding: "0px" }} colSpan={2}>
                        <div className="captcha">
                          {captchaText}{" "}
                          <FiRefreshCw
                            onClick={generateCaptcha}
                            className="captcha-icon"
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td className="floating-label-container">
                        <InputText
                          keyfilter={"int"}
                          value={text}
                          placeholder=" "
                          onChange={(e) => setText(e.target.value)}
                        />
                        <div className="label-line">Enter Captcha</div>
                        {invalid && (
                          <p
                            style={{
                              color: "red",
                              margin: "0",
                              marginTop: "10px",
                            }}
                          >
                            Invalid Captcha
                          </p>
                        )}
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={2}>
                        <Button
                          disabled={
                            !fullName ||
                            !emailID ||
                            !mobileNumber ||
                            !subject ||
                            !contactReason ||
                            !text
                          }
                          label="Submit"
                          type="submit"
                          className="buttonAvhrProject"
                        />

                      </td>
                    </tr>
                  </tbody>
                </table>
              </form>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactUsPage;
